import { Icon, InlineStack, Text } from "@shopify/polaris";

type tone =
  | "base"
  | "subdued"
  | "caution"
  | "warning"
  | "critical"
  | "interactive"
  | "info"
  | "success"
  | "primary"
  | "emphasis"
  | "magic"
  | "textCaution"
  | "textWarning"
  | "textCritical"
  | "textInfo"
  | "textSuccess"
  | "textPrimary"
  | "textMagic";

const HeaderWithIcon = (props: {
  title: string;
  tone?: tone;
  source?: any;
  SideChild?: JSX.Element;
  normal?: boolean;
  badge?: JSX.Element;
}) => {
  return (
    <InlineStack align="space-between">
      <InlineStack gap="200" blockAlign="center" wrap={false}>
        {props.source && <Icon tone={props.tone} source={props.source} />}
        <Text
          as={props.normal ? "p" : "h2"}
          variant={props.normal ? "bodyMd" : "headingMd"}
          fontWeight={props.normal ? undefined : "bold"}
        >
          {props.title}
        </Text>
        {props.badge}
      </InlineStack>
      {props.SideChild}
    </InlineStack>
  );
};

export default HeaderWithIcon;
